<template>
    <div class="main_wrap">
        <NavTab />
        
        <div class="form_case">
            <el-form ref="my_form" class="my_form" inline :model="model" label-width="80px" size="small">
                <el-form-item label="预约支队">
                    <el-select style="width:300px;" v-model="model.organizationId" placeholder="请选择" @change="onSelectZhidui">
                        <el-option v-for="item in zhiduiLists" :label="item.fullName" :key="item.id" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <!-- <el-form-item label="预约大队">
                    <el-select v-model="model.organizationId" placeholder="请选择">
                        <el-option v-for="item in daduiLists" :label="item.fullName" :key="item.id" :value="item.id"></el-option>
                    </el-select>
                </el-form-item> -->
                <el-form-item label="预约时段" v-if="amList.length > 0 || pmList.length > 0" >
                    <ul>
                        <li v-for="(item, index) in amList" :key="`am_${index}`">
                            上午
                            <el-input class="time_input" v-model="item.start" placeholder="请输入"></el-input>
                            -
                            <el-input class="time_input" v-model="item.end" placeholder="请输入"></el-input>
                        </li>
                        <li class="li_line"></li>
                        <li v-for="(item, index) in pmList" :key="`pm_${index}`">
                            下午
                            <el-input class="time_input" v-model="item.start" placeholder="请输入"></el-input>
                            -
                            <el-input class="time_input" v-model="item.end" placeholder="请输入"></el-input>
                        </li>
                    </ul>
                </el-form-item>
                <el-form-item v-if="amList.length > 0 || pmList.length > 0" >
                    <el-button class="my_btn" type="primary" @click="onSave">保存设置</el-button>
                </el-form-item>
            </el-form>
        </div>

    </div>
</template>

<script>
    import NavTab from "@/components/navTab.vue" 

    export default {
        name: "Time",
        components: {
            NavTab,
        },
        data() {
            return {
                model: {},
                zhiduiLists: [],
                daduiLists: [],
                amList: [],
                pmList: [],

            }
        },
        created() {
            this.getZhiduiLists();
        },
        mounted() {
            
        },
        methods: {
            // 获取支队列表
			getZhiduiLists() {
				this.$axios.get(`/admin/organization/childrenList/parent-1`).then(res => {
					let datas = this.AppUtils.checkResponse(res);
					let { code, data } = datas;
					if(code == 0) {
						this.zhiduiLists = data;
					}
				})
			},
            // 获取大队列表
			getDaduiLists(id) {
				this.$axios.get(`/admin/organization/childrenList/parent-${id}`).then(res => {
					let datas = this.AppUtils.checkResponse(res);
					let { code, data } = datas;
					if(code == 0) {
						this.daduiLists = data;
					}
				})
			},
            onSelectZhidui(e) {
                console.log(e)
                // this.getDaduiLists(e);
                this.getTimeView(e);
            },

            getTimeView(id) {
                this.$axios.post(`/admin/orderRule/get/${id}`).then(res => {
					let datas = this.AppUtils.checkResponse(res);
					let { code, data } = datas;
					if(code == 0) {
						let infos = JSON.parse(data.orderRule);
                        console.log(infos)
                        infos.forEach(item => {
                            if(item.dateType == "AM") {
                                this.amList = item.dataRule;
                            } else if(item.dateType == "PM") {
                                this.pmList = item.dataRule;
                            }
                        })
					}
				})
            },

            onSave() {
                // console.log(this.amList)
                // console.log(this.pmList)
                let arr = [
                    {dataRule: this.amList, dateType: "AM"},
                    {dataRule: this.pmList, dateType: "PM"},
                ]
                console.log(arr)
                // return
                this.$axios.post(`/admin/orderRule/update`, {
                    organizationId: this.model.organizationId,
                    dataRule: arr
                }).then(res => {
					let datas = this.AppUtils.checkResponse(res);
					let { code, data } = datas;
					if(code == 0) {
						this.$message.success("保存成功");
					}
				})
            },

        }
    }
</script>

<style lang="scss" scoped>
    .form_case {
        width: 100%;
        padding: 20px 0;
        background: #fff;
    }
    .my_form {
        width: 100%;
        display: flex;
        flex-flow: wrap;
    }
    .my_form ul li {
        margin: 0 0 10px 0;
    }
    .my_form ul .li_line {
        border-top: 1px dashed #ededed;
    }
    .time_input {
        width: 88px;
    }

    .my_btn {
        margin-left: 20px;
    }
    

</style>


// WEBPACK FOOTER //
// time.vue?c049d734